
export const map = () => {
    const mapTag = document.querySelector("#map");
    if (mapTag) {
        var map = L.map('map').setView([49.737039, 20.321289], 13);
        L.tileLayer('https://tile.openstreetmap.org/{z}/{x}/{y}.png', {
            maxZoom: 19,

        }).addTo(map);
        // Add a marker at the specified coordinates

        var greenIcon = L.icon({
            iconUrl: `${themeUrl}/src/img/logo-tymbark.png`,
            shadowUrl: 'leaf-shadow.png',

            iconSize: [86, 58], // size of the icon
            shadowSize: [50, 64], // size of the shadow
            iconAnchor: [22, 94], // point of the icon which will correspond to marker's location
            shadowAnchor: [4, 62],  // the same for the shadow
            popupAnchor: [-3, -76] // point from which the popup should open relative to the iconAnchor
        });
        var marker = L.marker([49.737039, 20.321289], { icon: greenIcon }).addTo(map);

        // Add the custom marker to the map
        L.marker([49.737039, 20.321289], { icon: greenIcon }).addTo(map)
            .bindPopup("<h6 class='contact__marker'>Bocianie gniazdo w Tymbarku.</h6>").openPopup();

    }

}

